import { render, staticRenderFns } from "./autocompletei.vue?vue&type=template&id=c0bd3492&scoped=true&"
import script from "./autocompletei.vue?vue&type=script&lang=js&"
export * from "./autocompletei.vue?vue&type=script&lang=js&"
import style0 from "./autocompletei.vue?vue&type=style&index=0&id=c0bd3492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bd3492",
  null
  
)

export default component.exports